import React from "react";
import { useState } from "react";
import TabPanel from "./TabPanel";

const ContentManagement = () => {
  const [pageType, setPageType] = useState("home");
  return (
    <>
      <title>Content Management</title>
      <div className="WrapperArea soloar_request">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <h4 className="Title">Content Management</h4>
            <div className="HelpArea mt-4">
              <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="false"
                    onClick={() => setPageType("home")}
                  >
                    Home
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-terms-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-terms"
                    type="button"
                    role="tab"
                    aria-controls="pills-terms"
                    aria-selected="true"
                    onClick={() => setPageType("terms")}
                  >
                    Terms & Conditions
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-about-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-about"
                    type="button"
                    role="tab"
                    aria-controls="pills-about"
                    aria-selected="false"
                    onClick={() => setPageType("about")}
                  >
                    About Us
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-contact-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-contact"
                    type="button"
                    role="tab"
                    aria-controls="pills-contact"
                    aria-selected="false"
                    onClick={() => setPageType("policy")}
                  >
                    Privacy & Policy
                  </button>
                </li>
              </ul>

              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <TabPanel title={"Home"} type={pageType} key="home" />
                </div>
                <div
                  className="tab-pane fade show"
                  id="pills-terms"
                  role="tabpanel"
                  aria-labelledby="pills-terms-tab"
                >
                  <TabPanel
                    title={"Terms & Condition"}
                    type={pageType}
                    key="terms"
                  />
                </div>
                <div
                  className="tab-pane fade show"
                  id="pills-about"
                  role="tabpanel"
                  aria-labelledby="pills-about-tab"
                >
                  <TabPanel title={"About Us"} type={pageType} key="about" />
                </div>
                <div
                  className="tab-pane fade show"
                  id="pills-contact"
                  role="tabpanel"
                  aria-labelledby="pills-contact-tab"
                >
                  <TabPanel
                    title={"Privacy Policy"}
                    type={pageType}
                    key="policy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentManagement;
